import { TreeStyles, TreeTemplate } from "@fluentui/web-components";
import { Tree } from "./tree";
import { DesignSystem } from "../design-system";
/**
 * The Fabric Tree component.
 *
 * @public
 */
export const definition = Tree.compose({
    name: `${DesignSystem.prefix}-tree`,
    template: TreeTemplate,
    styles: TreeStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=tree.definition.js.map